import { render, staticRenderFns } from "./my-collect-topic.vue?vue&type=template&id=3b2fabd6&scoped=true&"
import script from "./my-collect-topic.vue?vue&type=script&lang=js&"
export * from "./my-collect-topic.vue?vue&type=script&lang=js&"
import style0 from "./my-collect-topic.vue?vue&type=style&index=0&id=3b2fabd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2fabd6",
  null
  
)

export default component.exports